function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { Suspense } from 'react';
import { isTestMode } from 'seagull/utils/test-mode';
import { useStore, useStoreActions } from "./contexts";
import AuthProvider from "./providers/AuthProvider";
import "./infra/tailwind.css";
import "./infra/styles.scss";
import { EventReporterProvider } from "./event-reporter";
import { useLocation } from 'react-router-dom';
import { MediaQueriesProvider } from 'seagull/MediaQueries';
import ErrorBoundaryPage from "./components/ErrorBoundaryPage";
import { GlobalContextProvider, RootThemeProvider } from 'seagull';
import Main from "./pages/Main/Main";
import useEventTargets from "./event-reporter/event-targets/useEventTargets";
import { useOnMount } from "./hooks/useOnMount";
import { ModalCloseManagerProvider } from "./providers/ModalCloseManager";
import { LocationProvider } from "./providers/LocationProvider";
import SeagullIntentBehaviorProvider from "./providers/SeagullIntentBehaviorProvider";
import { getIntentBehavior } from "./infra/access-control";
import { getAuthTokenFromCookie } from "./utils/cookie.utils";
import LoadingIndicator from "./components/LoadingIndicator";
import { defaultTheme } from "./constants";
/** Wraps all modals with an error boundary modal. */

const ModalWrapper = props => /*#__PURE__*/React.createElement(ErrorBoundaryPage, _extends({
  isModal: true
}, props));

export function App() {
  const authDomain = useStore(state => state.session.authDomain);
  const {
    setAuthToken
  } = useStoreActions();
  const {
    search
  } = useLocation();
  useOnMount(() => {
    // Override feature-flags from URL.
    const featureFlags = new URLSearchParams(search).get('ff');
    document.cookie = "ff=".concat(featureFlags || '', "; path=/; ").concat(authDomain ? "domain=".concat(authDomain) : '');
    const authToken = getAuthTokenFromCookie(document.cookie);
    setAuthToken(authToken);
  });
  return /*#__PURE__*/React.createElement(SeagullIntentBehaviorProvider, {
    getIntentBehavior: getIntentBehavior
  }, /*#__PURE__*/React.createElement(ErrorBoundaryPage, null, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(LoadingIndicator, null)
  }, /*#__PURE__*/React.createElement(MediaQueriesProvider, null, /*#__PURE__*/React.createElement(LocationProvider, {
    location: window.location
  }, /*#__PURE__*/React.createElement(AuthProvider, null, /*#__PURE__*/React.createElement(GlobalContextProvider, {
    disableEnforceFocus: true,
    ModalWrapper: ModalWrapper,
    isTestMode: isTestMode
  }, /*#__PURE__*/React.createElement(ModalCloseManagerProvider, null, /*#__PURE__*/React.createElement(RootThemeProvider, {
    theme: defaultTheme
  }, /*#__PURE__*/React.createElement(Main, null))))))))));
}
export function AppWithEventReporter() {
  return /*#__PURE__*/React.createElement(EventReporterProvider, {
    eventTargets: useEventTargets()
  }, /*#__PURE__*/React.createElement(App, null));
}